import { Directionality, DIR_DOCUMENT } from '@angular/cdk/bidi';
import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Subscription } from 'rxjs';
import { Globle } from 'src/assets/globle';

import { Customer } from '../customer.model';
import { OptionService } from '../option.service';

@Component({
  selector: 'app-userbalance',
  templateUrl: './userbalance.component.html',
  styleUrls: ['./userbalance.component.css'],
  queries: {
    contentRef: new ViewChild("Modal")
  },
})
export class UserbalanceComponent implements OnInit {

  customers: Customer[] = [];
  displayedColumns: string[] = ['name', 'mobile', 'email', 'balance', "newbalance", "dept", "userCategoryId", "edit"];
  dataSource!: MatTableDataSource<Customer>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false
  public contentRef!: TemplateRef<any>;
  customer: Customer = {} as Customer;
  Catgstatus: { id: number, name: string }[] = [];
  selectedStatus: number = 1;
  userLoginId!: string;
  ballance: number = 0;
  role: string = "";
  userCategory: { id: number, name: string }[] = [];
  canUpdateUserCategory: boolean = true;

  color: ThemePalette = 'accent';
  //checked = true;
  pageSize = 100;
  constructor(private service: OptionService,
    private globle: Globle,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
    private dialog: MatDialog,
    private localStorage: LocalStorageService) {

  }

  ngOnInit() {
    this.userLoginId = this.localStorage.retrieve("userInfo").userId;
    this.ballance = this.localStorage.retrieve("userInfo").ballance;
    this.role = this.localStorage.retrieve("userInfo").role;
    const userInfo = this.localStorage.retrieve("userInfo");
    this.canUpdateUserCategory = this.role != 'Mandoob' || userInfo.canUpdateUserCategory === true;
    this.pageSize = this.globle.pageSize;
    this.getUserCategory();
    this.getCustomers();
    //this.getSystemSettings();
  }

  getCustomers() {
    this.spinnerOverlay = true;
    this.service.getAllCustomers(this.userLoginId).subscribe(data => {
      this.customers = data;
      this.dataSource = new MatTableDataSource(this.customers);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onDelete(id: string) {
    this.customer.id = id;
    this.openDialog();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  back() {

  }

  update(userData: any) {
    let obj = {
      userLoginId: this.userLoginId,
      userId: userData.id,
      balance: userData.newBallance,
      dept: userData.dept,
      usercategoryId: userData.userCategoryId
    }
    this.spinnerOverlay = true;
    this.service.updateUserBalance(obj).subscribe(data => {
      this.openSnackBar(this.translateService.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.ballance = this.ballance - userData.newBallance;

      // if (this.checked) {
      //   var _ballance = +userData.balance + +userData.newBallance
      //   if (_ballance != +userData.balance) {
      //     var message = "رصيدك الحالي " + _ballance;
      //     this.SendSMS(userData.userName, message);
      //   }
      // }
      //this.localStorage.store("userInfo.ballance",this.ballance);
      this.spinnerOverlay = false;

      let localStorageJsonData = this.localStorage.retrieve('userInfo');
      localStorageJsonData.ballance = this.ballance;
      this.localStorage.store("userInfo", localStorageJsonData);

      this.getCustomers();
    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
      this.openSnackBar(error.error.message, 'snackBarError');
    })
  }

  // SendSMS(mobileNo: string, message: string) {

  //   this.optionServices.sendOneByOneSMS(mobileNo, message).subscribe(data => {
  //     console.log(data);
  //   }, error => {
  //     console.log(error)
  //   })
  // }

  getUserCategory() {
    this.service.getUserCategory().subscribe(data => {
      this.userCategory = data;
    }, error => {
      console.log(error)
    })
  }

  getTotalBalance() {
    return this.customers.map(t => t.balance).reduce((acc, value) => acc + value, 0).toFixed(3);
  }

  // getSystemSettings() {
  //   this.service.getSystemSettings("SMS_Ballance").subscribe(data => {
  //     this.checked = JSON.parse(data["value"]);
  //   },
  //     error => {
  //       console.log(error);
  //     })
  // }

  // updateSystemSettings() {

  //   var obj = {
  //     "key": "SMS_Ballance",
  //     "value": this.checked
  //   }

  //   this.service.updateSystemSettings(obj).subscribe(data => {

  //   },
  //     error => {
  //       console.log(error);
  //     })
  // }

  // onChecked(event: any) {
  //   this.checked = event.checked;
  //   this.updateSystemSettings();
  // }

}
